import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ConservazioneCaricaDocumentoStep1Component} from './conservazione-carica-documento-step1';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.conservazione-carica-documento-step1', {
      url: '/conservazione-carica-step1/:classeDocumentale',
      params: {
        classeDocumentale: ''
      },
      ncyBreadcrumb: {
        label: 'Carica Documenti',
        parent: 'home.conservazione'
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Conservazione Carica Documento'
      },
      views: {
        homeContent: {
          template: '<conservazione-carica-documento-step1 flex="100"></conservazione-carica-documento-step1>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoStep1Module: string = ng
  .module('conservazione-carica-documento-step1', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('conservazioneCaricaDocumentoStep1', ConservazioneCaricaDocumentoStep1Component)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-step1/conservazione-carica-documento-step1.module.ts